export const PROGRESS_IMAGE_OFFSET = 10;
